import React from 'react';


import { makeStyles } from 'tss-react/mui';
import { ContentTemplate, Divider, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import GeneralTermsOfUse from '../../modules/helpdesk/termsOfUse/GeneralTermsOfUse';
import ProprietaryRightsTermsOfUse from '../../modules/helpdesk/termsOfUse/ProprietaryRightsTermsOfUse';
import PrivacyPolicyTermsOfUse from '../../modules/helpdesk/termsOfUse/PrivacyPolicyTermsOfUse';
import DisclaimerTermsOfUse from '../../modules/helpdesk/termsOfUse/DisclaimerTermsOfUse';
import RestrictionsTermsOfUse from '../../modules/helpdesk/termsOfUse/RestrictionsTermsOfUse';
import LinkTermsOfUse from '../../modules/helpdesk/termsOfUse/LinkTermsOfUse';
import GoverningLawTermsOfUse from '../../modules/helpdesk/termsOfUse/GoverningLawTermsOfUse';
import RightOfAccessTermsOfUse from '../../modules/helpdesk/termsOfUse/RightOfAccessTermsOfUse';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useTOCStyles = makeStyles()((theme) =>
({
  paragraph: {
    marginBottom: theme.spacing(1),
  },
}));

const TermsOfUse = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('helpdesk->>PageTitle.Terms of Use')} />

      <ContentTemplate>
        <GeneralTermsOfUse />
        <Divider />
        <ProprietaryRightsTermsOfUse />
        <Divider />
        <PrivacyPolicyTermsOfUse />
        <Divider />
        <DisclaimerTermsOfUse />
        <Divider />
        <RestrictionsTermsOfUse />
        <Divider />
        <RightOfAccessTermsOfUse />
        <Divider />
        <LinkTermsOfUse />
        <Divider />
        <GoverningLawTermsOfUse />
      </ContentTemplate>
    </>
  );
};
export default TermsOfUse;
